import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { ProgressBarComponent } from '@shared/components/progress-bar/progress-bar.component';

export interface ITokenUsageDialogData {
  title: string;
  message: string;
  closeText: string;
  usageValue: number | null;
  usageLabel: string;
}

@Component({
  imports: [MatDialogModule, MatButtonModule, ProgressBarComponent],
  selector: 'app-token-usage-dialog',
  styles: [
    `
      :host {
        mat-dialog-actions {
          padding: 0;
          padding-top: 16px;
        }

        mat-dialog-content {
          padding: 0;
          padding-top: 8px;
        }
      }
    `,
  ],
  template: `
    <div class="p-6">
      <span class="text-lg">{{ data.title }}</span>
      <mat-dialog-content>
        <p>{{ data.message }}</p>
        @if (data.usageValue !== null) {
          <div class="mt-4">
            <app-progress-bar
              progressLabelPosition="left"
              [current]="usagePercent"
              [total]="100"
              [currentColor]="progressBarColor"
              [label]="data.usageLabel"
              [isProgressLabelPercentage]="true"
              [progressLabelDecimalPlaces]="1"
            />
          </div>
        }
      </mat-dialog-content>
      <mat-dialog-actions align="start">
        <button mat-flat-button color="secondary" [mat-dialog-close]="true">
          {{ data.closeText }}
        </button>
      </mat-dialog-actions>
    </div>
  `,
})
export class TokenUsageDialogComponent {
  public readonly progressBarColor = 'var(--shikenso-info-base)';
  public readonly usagePercent: number;

  public readonly data = inject<ITokenUsageDialogData>(MAT_DIALOG_DATA);

  constructor() {
    this.usagePercent = Math.min((this.data.usageValue ?? 0) * 100, 100);
  }
}
